import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function Cuadro1EncuestaTranajadores() {
  const { idSolicitud } = useParams();

  const [totalEncuestas, setTotalEncuestas] = useState(0);
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const auth = {
    auth: {
      username: "BasicAuth@icontec.org",
      password: "yQLzqmR7eZSuAmQZUqhY",
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);

      try {
        const [conteoRes, resultadosRes] = await Promise.all([
          axios.get(
            `https://suadesarrollo.azurewebsites.net/api/ObtenerConteoEvaluaciones/2/${idSolicitud}`,
            auth,
          ),
          axios.get(
            `https://suadesarrollo.azurewebsites.net/api/ObtenerResultados/2/${idSolicitud}`,
            auth,
          ),
        ]);

        setTotalEncuestas(conteoRes.data || 0);
        setResultados(resultadosRes.data || []);
      } catch (err) {
        console.error("Error cargando datos:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (idSolicitud) fetchData();
  }, [idSolicitud]);

  /* =====================
     Filtros memorizados
     ===================== */
  const filtroSeleccion = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Seleccion"),
    [resultados],
  );

  const filtroAbierta = useMemo(
    () => resultados.filter((e) => e.tipoRespuesta === "Abierta"),
    [resultados],
  );

  const calcularPorcentaje = (valor) =>
    totalEncuestas > 0 ? Math.round((valor / totalEncuestas) * 100) : 0;

  if (loading) {
    return (
      <div className="text-center my-5">
        <span className="spinner-border text-primary" />
        <p className="mt-2">Cargando información...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center">
        Error al cargar la información de la encuesta.
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Información Encuestas
          </h6>
          <p>
            Encuestas realizadas:{" "}
            {totalEncuestas > 0 ? totalEncuestas : "No hay datos disponibles"}
          </p>
        </div>

        <div className="card-body">
          {filtroSeleccion.length === 0 && filtroAbierta.length === 0 ? (
            <p>No hay información disponible para mostrar.</p>
          ) : (
            <div className="table-responsive">
              {/* ===== TABLA ABIERTAS ===== */}
              {filtroAbierta.length > 0 && (
                <table
                  className="table table-bordered"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>VARIABLES EVALUADAS</th>
                      <th>% RESPUESTA CORRECTA</th>
                      <th>% RESPUESTA INCORRECTA</th>
                      <th>% RESPUESTA PARCIAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtroAbierta.map((item, index) => {
                      const correcta = calcularPorcentaje(item.completa);
                      const incorrecta = calcularPorcentaje(item.incompleta);
                      const parcial = calcularPorcentaje(item.parcial);

                      const pintar = (valor) =>
                        valor <= 75 ? { backgroundColor: "#f7c57aff" } : {};

                      return (
                        <tr key={index}>
                          <td className="text-justify">{item.pregunta}</td>
                          <td style={pintar(correcta)}>{correcta}%</td>
                          <td style={pintar(incorrecta)}>{incorrecta}%</td>
                          <td style={pintar(parcial)}>{parcial}%</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}

              {/* ===== TABLA SELECCIÓN ===== */}
              {filtroSeleccion.length > 0 && (
                <table
                  className="table table-bordered"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>VARIABLES EVALUADAS</th>
                      <th>% DE TRABAJADORES SI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtroSeleccion.map((item, index) => {
                      const si = calcularPorcentaje(item.afirmativo);

                      return (
                        <tr key={index}>
                          <td className="text-justify">{item.pregunta}</td>
                          <td>{si}%</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Cuadro1EncuestaTranajadores;
